module.exports = __webpack_public_path__ + "img/kaoshihint.f6470b84.png";